// @flow
import * as React from 'react';
import UseHighlightLine from 'esm-web-pro/hooks/useHighlightLine';
import { useLeaflet } from 'react-leaflet';
import L from 'leaflet';

function useHighlightFiber() {
    const leaflet = useLeaflet();
    const [routeGroup, setRouteGroup] = React.useState();
    const [cableGroup, setCableGroup] = React.useState();

    if (!routeGroup && !cableGroup) {
        setRouteGroup(L.featureGroup().addTo(leaflet.map));
        setCableGroup(L.featureGroup().addTo(leaflet.map));
    }

    const clearLayers = React.useCallback(() => {
        if (routeGroup && cableGroup) {
            routeGroup.clearLayers();
            cableGroup.clearLayers();
        }
    }, [routeGroup, cableGroup]);

    const highlightFunction = React.useCallback((path: Array<[number, number]>, dash: boolean) => UseHighlightLine(
        path,
        [{
            color: 'white',
            dashArray: dash ? '10 6' : null,
            className: 'fiber-line',
        },
        {
            dashArray: null, className: '',
        }],
        [
            { style: { color: '#616774', weight: 8 }, featureGroup: cableGroup },
            { style: { weight: 16 }, featureGroup: routeGroup },
        ],
    ), [
        routeGroup, cableGroup,
    ]);

    const cleanUp = React.useCallback(() => {
        if (routeGroup) routeGroup.remove();
        if (cableGroup) cableGroup.remove();
    }, [routeGroup, cableGroup]);

    return [highlightFunction, cleanUp, clearLayers];
}

export default useHighlightFiber;
